<template>
    <div>
        <div @click="onSectionHeaderClick"
             :class="{ selected: selection && selection.section === section.key && !selection.field, 'text-muted': !section.visible }"
             class="catalog-item font-18">
            <span class="grip-item pr-2">
                <i class="fa fa-grip-vertical"></i>
            </span>
            <span>{{ sectionLabel }}</span>

            <div v-if="!section.visible" class="float-right text-muted">
                <i class="fal fa-eye-slash"></i>
            </div>
            <AppExpandChevron v-else :show="expand" class="float-right align-self-center"/>
        </div>

        <div v-if="expand" class="ml-3">
            <draggable
                v-model="list"
                @change="onReorder"
                :animation="0"
                ghostClass="ghost">
                <transition-group type="transition" name="flip-list">
                    <div v-for="field in fields" :key="section.key + field.path"
                         :class="{'text-muted': !field.visible}">
                        <div @click="changeSelection({section: section.key, field: field.path})"
                             :class="{
                                 selected: selection && selection.section === section.key && selection.field === field.path,
                             }"
                             class="catalog-item">
                            <span class="grip-item pr-2 font-14">
                                <i class="fa fa-grip-vertical"></i>
                            </span>
                            <span>{{ getFieldLabel(field) }}</span>
                            <div v-if="!field.visible" class="float-right">
                                <i class="fal fa-eye-slash"></i>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import AppExpandChevron from '../../../../../components/shared/AppExpandChevron'
import {evaluateTeamLangPlaceholder} from '@/views/settings/team/lang'

export default {
    name: 'FormCatalogSection',
    components: {AppExpandChevron, draggable},
    props: {
        fields: {
            type: Array,
            required: true
        },
        section: {
            type: Object,
            required: true
        },
        selection: {
            type: Object,
            required: true
        },
        changeSelection: {
            type: Function,
            required: true
        },
        updateFields: {
            type: Function,
            required: true
        },
        collapse: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            list: null,
            expand: false
        }
    },
    computed: {
        sectionLabel() {
            return evaluateTeamLangPlaceholder(this.section.label)
        }
    },
    methods: {
        onReorder() {
            const updatedFields = this.list.map((f, idx) => ({...f, section: {...f.section, order: idx}}))
            this.updateFields(updatedFields)
        },

        onSectionHeaderClick() {
            this.changeSelection({section: this.section.key})
        },

        getFieldLabel(field) {
            return evaluateTeamLangPlaceholder(field.label)
        }
    },
    watch: {
        fields: {
            handler(list) {
                this.list = list
            },
            deep: true,
            immediate: true
        },
        collapse: {
            handler(v) {
                this.expand = v < 0
            },
            immediate: true
        },
        selection: {
            handler(next, prev) {
                if (next && next.section === this.section.key) {
                    if (next.field && (!prev.field || prev.field !== next.field)) {
                        this.expand = true
                    } else {
                        this.expand = !this.expand
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.catalog-item {
    padding: 8px 12px;

    &:hover, &.selected {
        background: $color-purple-soft;
        cursor: pointer;

        .grip-item {
            color: $color-purple-light;
        }
    }

    .grip-item {
        color: rgba(1, 1, 1, 0.2);

        &:hover {
            cursor: move;
        }
    }
}
</style>
